const MembershipsTab = ({ memberships, safeFormat }) => {
  return (
    <div className="bg-[#0B0F19] rounded-xl border border-[#D4AF37]/10 overflow-hidden">
      <div className="p-4 border-b border-[#D4AF37]/10">
        <h3 className="font-['Playfair_Display'] text-xl text-white">All Memberships</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full" data-testid="memberships-table">
          <thead className="bg-white/5">
            <tr>
              <th className="text-left p-4 text-white/50 text-sm font-medium">ID</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Plan</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Status</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Start</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Expiry</th>
            </tr>
          </thead>
          <tbody>
            {memberships.map((m) => (
              <tr key={m.id} className="border-t border-white/5">
                <td className="p-4 font-mono text-[#D4AF37] text-sm">{m.id.slice(0, 8)}</td>
                <td className="p-4 text-white">{m.plan_name}</td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${m.status === 'active' ? 'bg-[#047857]/20 text-[#047857]' : 'bg-red-500/20 text-red-400'}`}>
                    {m.status}
                  </span>
                </td>
                <td className="p-4 text-white/50 text-sm">{safeFormat(m.start_date, 'MMM d, yyyy')}</td>
                <td className="p-4 text-white/50 text-sm">{safeFormat(m.expiry_date, 'MMM d, yyyy')}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {memberships.length === 0 && (
          <p className="p-8 text-center text-white/40">No memberships yet</p>
        )}
      </div>
    </div>
  );
};

export default MembershipsTab;
